import axios from "axios";


//let serverUrl = "https://platforma.maxman.online";
let serverUrl = process.env.SERVER_URL;

export default{
    post(url, data) {
        var req = axios.post(serverUrl + "/" + url, data);
        req.then((res) => {
           //console.log(res);
        }).catch((res) => {
            //console.log(res);
        });
        return req;
    },
    get(url, data) {
        var req = axios.get(serverUrl + "/" + url, data);
        req.then((res) => {
            //console.log(res);
        }).catch((res) => {
            //console.log(res);
        });
        return req;
    },
    prependServerUrl(url){
        return serverUrl + "/" + url;
    },

    baseUrl: serverUrl
};



// WEBPACK FOOTER //
// ./src/public_app/api/server.js